export default __webpack_public_path__ + "static/CUBOID - REST ROOM CUBICLES & LOCKERS-de476cc78af689d20a1ef9d6fe883b70.webp";